import { gql } from "@apollo/client";
import { LinearProgress, Paper } from "@mui/material";
import ImageCanvas from "controls/ImageCanvas";
import useLoadedImage from "helpers/useLoadedImage";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import React from "react";

export default function CameraLiveImageTab({ cameraId }) {
  const [data] = useData(
    gql`
      query LiveImageTab($cameraId: ID!) {
        camera(id: $cameraId) {
          id
          liveImageUrl
          venue {
            allowCameraPreview
          }
        }
      }
    `,
    { cameraId },
  );
  const allowLiveImage = useIsAdmin() || data?.camera?.venue?.allowCameraPreview === true;

  const [liveImage, liveImageLoading] = useLoadedImage(allowLiveImage ? data?.camera?.liveImageUrl : null);

  return allowLiveImage ? (
    <>
      {liveImageLoading && <LinearProgress />}
      {liveImage && <ImageCanvas image={liveImage} style={{ width: "100%" }} />}
    </>
  ) : (
    <Paper elevation={2} sx={{ p: 2, textAlign: "center", color: "text.secondary" }}>
      Live image previews are not allowed at this venue.
    </Paper>
  );
}
